import { dateToReviewFormat } from '~/utils/dateUtils/dateToReviewFormat';
import { pipe } from '~/utils/pipe';
import { updateField } from '~/utils/updateField';

const formatStr = (first, last) => `${first || ''} ${last?.slice(0, 1) || ''}`.trim();
const getFullName = (obj) => formatStr(obj?.learner?.first_name, obj?.learner?.last_name);
const formatCreatedAt = (obj) => dateToReviewFormat(obj?.created_at);
const updateCreatedAt = updateField('created_at', formatCreatedAt);
const updateFullName = updateField('full_name', getFullName);
const updateReview = pipe(updateCreatedAt, updateFullName);

export default updateReview;
